import { defineComponent as q, ref as F, watch as D, computed as R, onMounted as T, onUnmounted as U, openBlock as r, createElementBlock as s, Fragment as v, renderList as p, createBlock as x, createElementVNode as w, createVNode as M, nextTick as W } from "vue";
import A from "./index19.js";
import h from "./index3.js";
const j = {
  key: 0,
  class: "base-select-stepper flex items-center gap-1"
}, I = {
  key: 1,
  class: "base-select-stepper-vertical flex flex-col gap-1"
}, O = { class: "flex gap-1" }, P = { class: "flex gap-1" }, K = /* @__PURE__ */ q({
  __name: "BaseSelectStepper",
  props: {
    modelValue: { default: void 0 },
    options: { default: () => [] },
    steps: { default: () => [0.1, 1] },
    size: { default: "sm" },
    disabled: { type: Boolean, default: !1 },
    min: { default: void 0 },
    max: { default: void 0 },
    placeholder: { default: "선택하세요" },
    layout: { default: "horizontal" }
  },
  emits: ["update:modelValue", "blur"],
  setup(l, { emit: N }) {
    const a = l, d = N, g = (e) => (a.min !== void 0 && (e = Math.max(e, a.min)), a.max !== void 0 && (e = Math.min(e, a.max)), e), k = F(void 0);
    D(
      () => a.modelValue,
      (e) => {
        e != null && Number.isFinite(e) && (k.value = g(e));
      },
      { immediate: !0 }
    );
    const C = (e) => Math.round(e * 1e10) / 1e10, m = (e) => {
      if (!Number.isFinite(e))
        return e.toString();
      const i = Math.round(e);
      return Math.abs(e - i) < 1e-10 ? i.toString() : e.toFixed(10).replace(/\.?0+$/, "");
    }, z = R(() => [...a.steps].sort((e, i) => i - e)), y = R(() => [...a.steps].sort((e, i) => e - i)), $ = (e) => {
      a.disabled || d("update:modelValue", g(C((a.modelValue ?? 0) - e)));
    }, B = (e) => {
      a.disabled || d("update:modelValue", g(C((a.modelValue ?? 0) + e)));
    }, S = (e) => a.disabled ? !1 : a.min === void 0 ? !0 : (a.modelValue ?? 0) - e >= a.min, E = (e) => a.disabled ? !1 : a.max === void 0 ? !0 : (a.modelValue ?? 0) + e <= a.max, L = () => {
      a.modelValue == null && k.value != null && d("update:modelValue", k.value), d("blur");
    }, o = F(null);
    let u = null;
    const b = () => {
      u !== null && window.cancelAnimationFrame(u), u = window.requestAnimationFrame(() => {
        W(() => {
          if (!o.value) return;
          const e = o.value.querySelector('[role="listbox"]');
          if (!e) return;
          const i = o.value.querySelector("input");
          if (!i) return;
          const t = i.getBoundingClientRect(), n = o.value.getBoundingClientRect();
          e.style.position = "fixed", e.style.top = `${t.bottom + 4}px`, e.style.left = `${n.left}px`, e.style.width = `${n.width}px`;
        });
      });
    };
    let c = null;
    const f = () => {
      b();
    };
    return T(() => {
      o.value && (c = new MutationObserver(() => {
        b();
      }), c.observe(o.value, {
        childList: !0,
        subtree: !0,
        attributes: !0,
        attributeFilter: ["style", "class"]
      }), o.value.addEventListener("click", b), window.addEventListener("scroll", f, !0), window.addEventListener("resize", f));
    }), U(() => {
      c && (c.disconnect(), c = null), u !== null && (window.cancelAnimationFrame(u), u = null), o.value && o.value.removeEventListener("click", b), window.removeEventListener("scroll", f, !0), window.removeEventListener("resize", f);
    }), (e, i) => l.layout === "horizontal" ? (r(), s("div", j, [
      (r(!0), s(v, null, p(z.value, (t, n) => (r(), x(h, {
        key: `left-${n}`,
        label: `-${m(t)}`,
        variant: n === 0 ? "light" : "contained-grey",
        color: n === 0 ? "blue" : "black",
        size: l.size,
        customClass: "border-none px-padding-16 min-w-[52px]",
        disabled: l.disabled || !S(t),
        onClick: (V) => $(t)
      }, null, 8, ["label", "variant", "color", "size", "disabled", "onClick"]))), 128)),
      w("div", {
        ref_key: "comboboxWrapperRef",
        ref: o,
        class: "base-select-stepper-combobox-wrapper relative w-full min-w-[112px] flex-1"
      }, [
        M(A, {
          "model-value": l.modelValue,
          options: l.options,
          size: l.size,
          disabled: l.disabled,
          min: l.min,
          max: l.max,
          "allow-free-input": !0,
          placeholder: l.placeholder,
          "onUpdate:modelValue": i[0] || (i[0] = (t) => d("update:modelValue", t)),
          onBlur: L
        }, null, 8, ["model-value", "options", "size", "disabled", "min", "max", "placeholder"])
      ], 512),
      (r(!0), s(v, null, p(y.value, (t, n) => (r(), x(h, {
        key: `right-${n}`,
        label: `+${m(t)}`,
        variant: n === y.value.length - 1 ? "light" : "contained-grey",
        color: n === y.value.length - 1 ? "red" : "black",
        size: l.size,
        customClass: "border-none px-padding-16 min-w-[52px]",
        disabled: l.disabled || !E(t),
        onClick: (V) => B(t)
      }, null, 8, ["label", "variant", "color", "size", "disabled", "onClick"]))), 128))
    ])) : (r(), s("div", I, [
      w("div", O, [
        (r(!0), s(v, null, p(z.value, (t, n) => (r(), x(h, {
          key: `top-${n}`,
          label: `+${m(t)}`,
          variant: n === 0 ? "light" : "contained-grey",
          color: n === 0 ? "red" : "black",
          size: l.size,
          customClass: "border-none px-padding-16 flex-1 min-w-[52px]",
          disabled: l.disabled || !E(t),
          onClick: (V) => B(t)
        }, null, 8, ["label", "variant", "color", "size", "disabled", "onClick"]))), 128))
      ]),
      w("div", {
        ref_key: "comboboxWrapperRef",
        ref: o,
        class: "base-select-stepper-combobox-wrapper relative w-full"
      }, [
        M(A, {
          "model-value": l.modelValue,
          options: l.options,
          size: l.size,
          disabled: l.disabled,
          min: l.min,
          max: l.max,
          "allow-free-input": !0,
          placeholder: l.placeholder,
          "onUpdate:modelValue": i[1] || (i[1] = (t) => d("update:modelValue", t)),
          onBlur: L
        }, null, 8, ["model-value", "options", "size", "disabled", "min", "max", "placeholder"])
      ], 512),
      w("div", P, [
        (r(!0), s(v, null, p(z.value, (t, n) => (r(), x(h, {
          key: `bottom-${n}`,
          label: `-${m(t)}`,
          variant: n === 0 ? "light" : "contained-grey",
          color: n === 0 ? "blue" : "black",
          size: l.size,
          customClass: "border-none px-padding-16 flex-1 min-w-[60px]",
          disabled: l.disabled || !S(t),
          onClick: (V) => $(t)
        }, null, 8, ["label", "variant", "color", "size", "disabled", "onClick"]))), 128))
      ])
    ]));
  }
});
export {
  K as default
};
